import { createContext } from 'react';

const contextGlobalKey = '__StyleCollectorContext';

const StyleCollectorContext = createContext<
  | {
      addStyles(id: string, css: string): void;
    }
  | undefined
>(undefined);

export function getStyleCollectorContext() {
  if (!global.tamagoshi) {
    global.tamagoshi = {};
  }

  if (!global.tamagoshi[contextGlobalKey]) {
    global.tamagoshi[contextGlobalKey] = StyleCollectorContext;
  }

  return global.tamagoshi[contextGlobalKey] as typeof StyleCollectorContext;
}
